var _rect, _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_40487",
    "data-name": "Group 40487",
    xmlns: "http://www.w3.org/2000/svg",
    width: 214.016,
    height: 70,
    viewBox: "0 0 214.016 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23565",
    "data-name": "Rectangle 23565",
    width: 214.016,
    height: 70,
    rx: 5,
    fill: "#231f20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72697",
    "data-name": "Path 72697",
    d: "M793.24,183.243H775.808a3.781,3.781,0,0,0-3.784,3.78V225.64a3.784,3.784,0,0,0,3.784,3.784H793.24a3.784,3.784,0,0,0,3.784-3.784V187.023A3.78,3.78,0,0,0,793.24,183.243Zm-8.718,43.4a2.519,2.519,0,1,1,2.521-2.521A2.521,2.521,0,0,1,784.522,226.647Zm9.529-6.266H775V191.9h19.055Z",
    transform: "translate(-756.278 -171.269)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40485",
    "data-name": "Group 40485",
    transform: "translate(52.601 11.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72698",
    "data-name": "Path 72698",
    d: "M783.846,190.21l-1.059,3.208h-1.365l3.467-10.2h1.592l3.482,10.2h-1.407l-1.09-3.208Zm3.345-1.028-1.016-2.937c-.212-.667-.361-1.275-.514-1.863h-.043c-.137.588-.3,1.227-.5,1.847l-1,2.953Z",
    transform: "translate(-781.422 -182.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72699",
    "data-name": "Path 72699",
    d: "M785,183.948l1.439,4.1c.243.682.439,1.286.592,1.894h.043c.168-.608.376-1.212.619-1.894l1.424-4.1h1.392l-2.874,7.325h-1.275l-2.78-7.325Z",
    transform: "translate(-775.103 -180.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72700",
    "data-name": "Path 72700",
    d: "M791.19,189.643a12.459,12.459,0,0,0,.106,1.753h-1.2l-.122-.922h-.047a2.7,2.7,0,0,1-2.239,1.09,2.087,2.087,0,0,1-2.239-2.106c0-1.769,1.573-2.737,4.4-2.725v-.149a1.5,1.5,0,0,0-1.663-1.694,3.567,3.567,0,0,0-1.925.541l-.3-.894a4.755,4.755,0,0,1,2.42-.631c2.259,0,2.8,1.525,2.8,3Zm-1.3-1.984c-1.455-.031-3.1.227-3.1,1.651a1.166,1.166,0,0,0,1.239,1.271,1.85,1.85,0,0,0,1.8-1.227,1.319,1.319,0,0,0,.063-.424Z",
    transform: "translate(-769.645 -180.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72701",
    "data-name": "Path 72701",
    d: "M788.221,184.878a.873.873,0,1,1,.02,0Zm-.632,8.674v-7.325h1.33v7.325Z",
    transform: "translate(-763.986 -182.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72702",
    "data-name": "Path 72702",
    d: "M788.324,183.076h1.333v10.745h-1.333Z",
    transform: "translate(-761.258 -183.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72703",
    "data-name": "Path 72703",
    d: "M794.8,189.643a12.422,12.422,0,0,0,.106,1.753h-1.2l-.122-.922h-.047a2.7,2.7,0,0,1-2.239,1.09,2.087,2.087,0,0,1-2.239-2.106c0-1.769,1.573-2.737,4.4-2.725v-.149a1.5,1.5,0,0,0-1.667-1.694,3.555,3.555,0,0,0-1.922.541l-.3-.894a4.758,4.758,0,0,1,2.424-.631c2.255,0,2.8,1.525,2.8,3Zm-1.3-1.984c-1.455-.031-3.106.227-3.106,1.651a1.169,1.169,0,0,0,1.243,1.271,1.85,1.85,0,0,0,1.8-1.227,1.319,1.319,0,0,0,.063-.424Z",
    transform: "translate(-759.102 -180.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72704",
    "data-name": "Path 72704",
    d: "M791.093,183.076h1.333v4.584h.031a2.722,2.722,0,0,1,2.5-1.329c1.816,0,3.086,1.514,3.086,3.721,0,2.635-1.663,3.937-3.3,3.937a2.617,2.617,0,0,1-2.451-1.38h-.031l-.078,1.212h-1.149c.047-.5.059-1.239.059-1.89Zm1.333,7.812a2.433,2.433,0,0,0,.047.482,2.068,2.068,0,0,0,2,1.561c1.412,0,2.228-1.137,2.228-2.816,0-1.486-.757-2.741-2.18-2.741a2.116,2.116,0,0,0-2.016,1.635,2.178,2.178,0,0,0-.075.561Z",
    transform: "translate(-753.34 -183.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72705",
    "data-name": "Path 72705",
    d: "M793.227,183.076h1.329v10.745h-1.329Z",
    transform: "translate(-746.934 -183.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72706",
    "data-name": "Path 72706",
    d: "M795.261,187.973a2.337,2.337,0,0,0,2.5,2.545,5.07,5.07,0,0,0,2.031-.365l.239.937a5.953,5.953,0,0,1-2.451.471,3.419,3.419,0,0,1-3.6-3.694c0-2.224,1.318-3.965,3.455-3.965,2.388,0,3.012,2.106,3.012,3.451a3.339,3.339,0,0,1-.047.635Zm3.89-.953a1.9,1.9,0,0,0-1.831-2.165,2.2,2.2,0,0,0-2.043,2.165Z",
    transform: "translate(-744.748 -180.663)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72707",
    "data-name": "Path 72707",
    d: "M800.2,191.565a3.492,3.492,0,0,1-3.51-3.769,3.584,3.584,0,0,1,3.631-3.89,3.461,3.461,0,0,1,3.525,3.753,3.589,3.589,0,0,1-3.631,3.906Zm.047-1c1.271,0,2.224-1.2,2.224-2.863,0-1.239-.62-2.8-2.192-2.8s-2.243,1.455-2.243,2.847c0,1.6.91,2.816,2.2,2.816Z",
    transform: "translate(-736.819 -180.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72708",
    "data-name": "Path 72708",
    d: "M798.971,186.055c0-.773-.016-1.376-.063-1.984h1.18l.075,1.2h.031a2.713,2.713,0,0,1,2.423-1.361c1.012,0,2.588.6,2.588,3.118V191.4h-1.333v-4.223c0-1.177-.439-2.18-1.694-2.18a1.928,1.928,0,0,0-1.788,1.365,2.01,2.01,0,0,0-.09.62v4.42h-1.329Z",
    transform: "translate(-730.336 -180.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72709",
    "data-name": "Path 72709",
    d: "M804.072,183.5v1.757h1.906v1.016h-1.906v3.949c0,.91.255,1.423,1,1.423a2.587,2.587,0,0,0,.776-.09l.059,1.012a3.541,3.541,0,0,1-1.18.184,1.9,1.9,0,0,1-1.439-.561,2.85,2.85,0,0,1-.514-1.922v-4h-1.137v-1.016h1.137v-1.349Z",
    transform: "translate(-722.375 -181.837)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72710",
    "data-name": "Path 72710",
    d: "M803.1,183.076h1.329v4.569h.031a2.384,2.384,0,0,1,.953-.937,2.593,2.593,0,0,1,1.365-.376c.984,0,2.557.6,2.557,3.133v4.357H808.01v-4.208c0-1.192-.443-2.18-1.7-2.18a1.927,1.927,0,0,0-1.784,1.333,1.563,1.563,0,0,0-.094.635v4.42H803.1Z",
    transform: "translate(-718.078 -183.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72711",
    "data-name": "Path 72711",
    d: "M806.381,187.973a2.335,2.335,0,0,0,2.5,2.545,5.062,5.062,0,0,0,2.027-.365l.243.937a5.99,5.99,0,0,1-2.455.471,3.419,3.419,0,0,1-3.6-3.694c0-2.224,1.318-3.965,3.455-3.965,2.392,0,3.012,2.106,3.012,3.451a3.322,3.322,0,0,1-.047.635Zm3.89-.953a1.9,1.9,0,0,0-1.831-2.165,2.2,2.2,0,0,0-2.047,2.165Z",
    transform: "translate(-712.273 -180.663)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72712",
    "data-name": "Path 72712",
    d: "M808.725,184.878a.869.869,0,1,1,.012,0Zm-.639,8.674v-7.325h1.333v7.325Z",
    transform: "translate(-704.095 -182.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72713",
    "data-name": "Path 72713",
    d: "M808.836,183.407a13.811,13.811,0,0,1,2.525-.212,4.173,4.173,0,0,1,2.863.851,2.755,2.755,0,0,1,.906,2.133,2.938,2.938,0,0,1-.8,2.177,4.216,4.216,0,0,1-3.117,1.122,4.653,4.653,0,0,1-1.063-.09v4.086h-1.314Zm1.314,4.906a4.6,4.6,0,0,0,1.09.106c1.608,0,2.561-.788,2.561-2.165,0-1.361-.953-2.012-2.408-2.012a6.575,6.575,0,0,0-1.243.106Z",
    transform: "translate(-701.332 -182.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72714",
    "data-name": "Path 72714",
    d: "M810.839,183.076h1.333v4.569h.031a2.384,2.384,0,0,1,.953-.937,2.58,2.58,0,0,1,1.361-.376c.985,0,2.561.6,2.561,3.133v4.357h-1.333v-4.208c0-1.192-.439-2.18-1.7-2.18a1.935,1.935,0,0,0-1.784,1.333,1.633,1.633,0,0,0-.09.635v4.42h-1.333Z",
    transform: "translate(-695.48 -183.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72715",
    "data-name": "Path 72715",
    d: "M816.341,191.565a3.493,3.493,0,0,1-3.514-3.769,3.584,3.584,0,0,1,3.635-3.89,3.463,3.463,0,0,1,3.525,3.753,3.591,3.591,0,0,1-3.632,3.906Zm.047-1c1.267,0,2.224-1.2,2.224-2.863,0-1.239-.62-2.8-2.2-2.8-1.561,0-2.243,1.455-2.243,2.847,0,1.6.91,2.816,2.2,2.816Z",
    transform: "translate(-689.672 -180.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72716",
    "data-name": "Path 72716",
    d: "M815.106,186.055c0-.773-.016-1.376-.059-1.984h1.18l.074,1.2h.031a2.711,2.711,0,0,1,2.419-1.361c1.016,0,2.588.6,2.588,3.118V191.4h-1.329v-4.223c0-1.177-.439-2.18-1.7-2.18a1.923,1.923,0,0,0-1.784,1.365,1.9,1.9,0,0,0-.094.62v4.42h-1.329Z",
    transform: "translate(-683.186 -180.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72717",
    "data-name": "Path 72717",
    d: "M818.336,187.973a2.337,2.337,0,0,0,2.5,2.545,5.049,5.049,0,0,0,2.027-.365l.243.937a5.969,5.969,0,0,1-2.451.471,3.417,3.417,0,0,1-3.6-3.694c0-2.224,1.318-3.965,3.451-3.965,2.392,0,3.012,2.106,3.012,3.451a3.773,3.773,0,0,1-.043.635Zm3.89-.953a1.9,1.9,0,0,0-1.831-2.165,2.192,2.192,0,0,0-2.043,2.165Z",
    transform: "translate(-677.334 -180.663)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40486",
    "data-name": "Group 40486",
    transform: "translate(52.322 28.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72718",
    "data-name": "Path 72718",
    d: "M790.323,187.579,781.351,214h4.11l2.678-8.114h8.69L799.586,214h4.224l-9.016-26.419Zm2.129,4.341c.306,1.18.631,2.4,1.051,3.729l2.42,7h-6.882l2.384-7.051C791.79,194.461,792.131,193.226,792.453,191.92Z",
    transform: "translate(-781.351 -187.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72719",
    "data-name": "Path 72719",
    d: "M797.618,189.325a7.479,7.479,0,0,0-6.357,3.051l-.157-2.631h-3.659l.024.337c.106,1.639.153,3.439.153,6.027v20.365h4v-9.5a7.018,7.018,0,0,0,5.463,2.345,8.246,8.246,0,0,0,6.059-2.573,10.92,10.92,0,0,0,2.675-7.69,10.623,10.623,0,0,0-2.322-7.019A7.6,7.6,0,0,0,797.618,189.325Zm-1,3.31c3.564,0,5.157,3.3,5.157,6.572,0,4.22-2.035,6.839-5.31,6.839a4.848,4.848,0,0,1-4.71-3.71,5.215,5.215,0,0,1-.141-1.294v-3.212a5.876,5.876,0,0,1,.129-.988c.02-.11.039-.22.055-.326A5.063,5.063,0,0,1,796.623,192.635Z",
    transform: "translate(-763.544 -182.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72720",
    "data-name": "Path 72720",
    d: "M802.868,189.325a7.483,7.483,0,0,0-6.357,3.051l-.157-2.631H792.7l.024.337c.106,1.639.153,3.439.153,6.027v20.365h4v-9.5a7.025,7.025,0,0,0,5.463,2.345,8.261,8.261,0,0,0,6.063-2.573,10.938,10.938,0,0,0,2.671-7.69,10.644,10.644,0,0,0-2.322-7.019A7.6,7.6,0,0,0,802.868,189.325Zm-1,3.31c3.565,0,5.157,3.3,5.157,6.572,0,4.22-2.035,6.839-5.31,6.839a4.848,4.848,0,0,1-4.71-3.71,5.2,5.2,0,0,1-.141-1.294v-3.212a6,6,0,0,1,.13-.992l.059-.322A5.056,5.056,0,0,1,801.871,192.635Z",
    transform: "translate(-748.209 -182.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72721",
    "data-name": "Path 72721",
    d: "M808.956,199.087c-3.729-1.443-4.926-2.58-4.926-4.678,0-1.769,1.4-3.549,4.541-3.549a9.081,9.081,0,0,1,4.694,1.176l.337.208,1.129-3.333-.224-.133a11.583,11.583,0,0,0-5.82-1.306c-5.1,0-8.659,3.012-8.659,7.318,0,3.474,2.228,5.9,7.016,7.643,3.392,1.267,4.655,2.569,4.655,4.8,0,2.518-1.949,4.082-5.083,4.082a10.945,10.945,0,0,1-5.761-1.635l-.345-.22-1.074,3.412.2.129a13.7,13.7,0,0,0,6.757,1.737c6.871,0,9.306-4.188,9.306-7.776C815.7,203.259,813.744,200.977,808.956,199.087Z",
    transform: "translate(-728.51 -187.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72722",
    "data-name": "Path 72722",
    d: "M810.476,188.272l-3.921,1.231v3.318h-2.867v3.2h2.867v9.788c0,2.365.455,4.023,1.384,5.07a5.129,5.129,0,0,0,3.871,1.518,9.5,9.5,0,0,0,3.09-.474l.224-.082-.192-3.2-.385.118a5.966,5.966,0,0,1-1.859.216c-1.549,0-2.212-.98-2.212-3.282v-9.67H815.3v-3.2h-4.823Z",
    transform: "translate(-716.093 -185.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72723",
    "data-name": "Path 72723",
    d: "M816.251,189.325c-5.592,0-9.5,4.176-9.5,10.149,0,5.8,3.78,9.843,9.192,9.843h.035c4.576,0,9.5-3.188,9.5-10.184a10.1,10.1,0,0,0-2.549-7.071A8.9,8.9,0,0,0,816.251,189.325Zm-.114,3.157c3.6,0,5.231,3.506,5.231,6.765,0,4.008-2.235,6.918-5.31,6.918h-.039c-3.031,0-5.232-2.863-5.232-6.8C810.788,195.937,812.443,192.482,816.137,192.482Z",
    transform: "translate(-707.139 -182.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72724",
    "data-name": "Path 72724",
    d: "M822.066,189.513l-.239-.063a3.922,3.922,0,0,0-1-.125,5.7,5.7,0,0,0-5.012,3.22l-.117-2.8h-3.588l.024.337c.106,1.584.153,3.361.153,5.757L812.25,208.9h4V198.709a10.548,10.548,0,0,1,.11-1.549c.451-2.447,2.1-4.027,4.2-4.027a9.742,9.742,0,0,1,1.074.067l.427.043Z",
    transform: "translate(-691.479 -182.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72725",
    "data-name": "Path 72725",
    d: "M823.677,189.316c-5.322,0-9.039,4.251-9.039,10.337,0,5.863,3.7,9.655,9.419,9.655a15.329,15.329,0,0,0,6.33-1.216l.239-.11-.765-2.976-.333.133a12.4,12.4,0,0,1-5.012.894c-1.737,0-5.741-.573-5.984-5.8l12.9.039.051-.255a8.756,8.756,0,0,0,.122-1.667C831.607,194.183,829.528,189.316,823.677,189.316Zm-.267,3.039a3.936,3.936,0,0,1,2.933,1.122,5.677,5.677,0,0,1,1.376,3.718h-9.114C818.975,194.888,820.418,192.355,823.41,192.355Z",
    transform: "translate(-684.103 -182.081)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/App Store.17a4d9453875cc9a5c1694c054515225.svg";
export { ForwardRef as ReactComponent };